import FilterConstants from '../../filter-constants';

const _optimizationsList = [
  FilterConstants.optimizationType.voltageRange,
  FilterConstants.optimizationType.noise,
  FilterConstants.optimizationType.power,
];
const _choiceOptions = [
  FilterConstants.optimizationPreferenceOptions.nonSpecific,
  FilterConstants.optimizationPreferenceOptions.specific,
];

export default class ComponentSelectionInput {
  optimizationPreferenceOptions;
  optimizationsList;

  choiceOptions;
  vsMinus; // double
  vsPlus; // double
  compensateForGbw = false;
  optimization; // e.g FilterConstants.optimizationType.power
  optimizationPreference; // e.g: specific or FilterConstants.optimizationPreferenceOptions.recommendedSpecific
  individualStageInputs; // inputs/component-selection/individual-stage [1..6]
  sortOrder;
  preferredAlgorithms;

  constructor(args) {
    this.optimizationList = _optimizationsList;
    this.choiceOptions = _choiceOptions;

    if (args) {
      this.choiceOptions = args.choiceOptions ?? null;
      this.vsMinus = args.vsMinus ?? null;
      this.vsPlus = args.vsPlus ?? null;
      this.compensateForGbw = args.compensateForGbw ?? null;
      this.optimization = args.optimization ?? null;
      this.optimizationPreference = args.optimizationPreference ?? null;
      this.individualStageInputs = args.individualStageInputs ?? [];
      this.sortOrder = args.sortOrder ?? [];
      this.preferredAlgorithms = args.preferredAlgorithms ?? null;
    }
  }
}
